import { Box, FormLabel } from "@mui/material"
import BaseColorText from "../BaseColorText"
import BaseInput from "../BaseInput"

const BirthInputGroup = ({ sx, title,  values, onChange, onBlur, touched, errors }) => {
  return (
    <Box sx={{ ...sx }}>
      <FormLabel
        sx={{
          fontSize: '12px',
          fontWeight: 500,
          mb: '1px',
          color: '#46545F'
        }}
      >
        {title}
        <BaseColorText color='#E73E3E'>*</BaseColorText>
      </FormLabel>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        <BaseInput
          sx={{
            minWidth: '80px'
          }}
          inputProps={{
            style: {
              textAlign: 'center'
            }
          }}
          label=''
          name='birthMonth'
          type='text'
          placeholder='mm'
          value={values.birthMonth || ''}
          onChange={onChange}
          onBlur={onBlur}
          helperText={touched.birthMonth ? errors.birthMonth : ""}
          error={touched.birthMonth && Boolean(errors.birthMonth)}
          required
        />
        <Box 
          sx={{
            width: '100%',
            height: '1px',
            bgcolor: 'primary.lightGray',
            mx: '8px'
          }}
        />
        <BaseInput
          sx={{
            minWidth: '80px'
          }}
          inputProps={{
            style: {
              textAlign: 'center'
            }
          }}
          label=''
          name='birthDate'
          type='text'
          placeholder='dd'
          value={values.birthDate || ''}
          onChange={onChange}
          onBlur={onBlur}
          helperText={touched.birthDate ? errors.birthDate : ""}
          error={touched.birthDate && Boolean(errors.birthDate)}
          required
        />
        <Box 
          sx={{
            width: '100%',
            height: '1px',
            bgcolor: 'primary.lightGray',
            mx: '8px'
          }}
        />
        <BaseInput
          sx={{
            minWidth: '80px'
          }}
          inputProps={{
            style: {
              textAlign: 'center'
            }
          }}
          label=''
          name='birthYear'
          type='text'
          placeholder='year'
          value={values.birthYear || ''}
          onChange={onChange}
          onBlur={onBlur}
          helperText={touched.birthYear ? errors.birthYear : ""}
          error={touched.birthYear && Boolean(errors.birthYear)}
          required
        />
      </Box>
    </Box>
  )
}

export default BirthInputGroup